
import React from 'react';
import { compose, withState, defaultProps } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';

import { withLocale } from 'op/components/locale';


const ReportDeleteModal = ({ locale, openModal, setOpenModal, onDelete, online, isStp }) => (
	<Modal
		trigger={
			<Button
				disabled={!online}
				color='red'
				onClick={() => setOpenModal(true)}
			>
				{locale._system.delete}
			</Button>
		}
		open={openModal}
		onClose={() => setOpenModal(false)}
		basic
	>
		<Header icon='th list' content={isStp ? locale.stpHeader : locale.header} />
		<Modal.Content>
			{(
				isStp ? locale.stpContent : locale.content
			).map((line, i) => <p key={i}>{line}</p>)}
		</Modal.Content>
		<Modal.Actions>
			<Button basic onClick={() => setOpenModal(false)} inverted floated='left'>
				<Icon name='remove' /> {locale._system.cancel}
			</Button>
			<Button onClick={() => { onDelete(); setOpenModal(false); }} color='red' inverted>
				<Icon name='trash' /> {locale._system.delete}
			</Button>
		</Modal.Actions>
	</Modal>
);

export default compose(
	hot(module),
	withLocale('report.delete'),
	withState('openModal', 'setOpenModal', false),
	defaultProps({
		onDelete: () => { },
	}),
)(ReportDeleteModal);
